<template>
  <section id="about" class="about">

    <div class="container">

      <div class="section-header">

        <h2 class="section-title">

          <span class="gradient-text">
            {{ titlesLocale.first }}
          </span>

          {{ titlesLocale.second }}

        </h2>

      </div>

      <div class="about-grid">

        <div class="about-cards">

          <div
            v-for="(card, index) in aboutCards"
            :key="index"
            class="about-card"
          >

            <div class="card-header">

              <div class="icon-box icon-primary">

                <img
                  :src="card.icon"
                  :alt="card.alt"
                  class="about-icon"
                />

              </div>

              <div>

                <h3 class="gradient-text">
                  {{ card.title }}
                </h3>

                <p class="card-subtitle">
                  {{ card.subtitle }}
                </p>

              </div>

            </div>

            <div class="card-text">

              <p
                v-for="(text, i) in card.paragraphs"
                :key="i"
              >
                {{ text }}
              </p>

            </div>

          </div>

        </div>

      </div>

    </div>

  </section>
</template>

<script setup>
import { computed } from "vue"
import { useI18n } from "vue-i18n"
import { sobre, titles } from "@/data/sobre"

const { locale } = useI18n()

const aboutCards = computed(() => {

  if (locale.value === "pt") {
    return sobre.pt
  }
  return sobre.en
})

const titlesLocale = computed(() => {

  if (locale.value === "pt") {
    return titles.pt
  }
  return titles.en
})
</script>

<style scoped>
.about {
  position: relative;
  padding: 50px 20px;
  background: var(--bg-secundario);
  scroll-margin-top: 90px;
}

.section-header {
  text-align: center;
  margin-bottom: 40px;
}

.section-title {
  font-family: 'Orbitron', sans-serif;
  font-size: clamp(24px, 4vw, 48px);
}

.about-grid {
  display: flex;
}

.about-cards {
  width: 100%;
  display: flex;
  justify-content: space-around;
}

.about-card {
  width: 420px;
  background: var(--bg-destaque);
  border: 1px solid var(--card-base);
  border-radius: 20px;
  padding: 20px 30px;
  transition: 0.3s;
}

.about-card:hover {
  transform: translateY(-5px);
  border-color: var(--card-destaque);
}

.card-header {
  display: flex;
  gap: 4px;
  margin-bottom: 20px;
  align-items: center;
}

.card-header h3 {
  font-size: 22px;
  line-height: 1.5;
}

.icon-box {
  padding: 8px;
  border-radius: 12px;
}

.about-icon {
  width: 35px;
  height: 35px;
  object-fit: contain;
}

.card-subtitle {
  color: var(--cor-texto-suave);
  font-size: 14px;
}

.card-text {
  color: var(--cor-texto-secundario);
}

.card-text p {
  font-size: 15px;
  margin-bottom: 16px;
  line-height: 1.5;
}

.card-text p:last-child {
  margin-bottom: 0;
}

@media (max-width: 1280px) {

  .about-cards {
    gap: 20px;
    justify-content: center;
  }

  .about-card {
    width: 400px;
    padding: 20px;
  }

  .card-header h3 {
    font-size: 20px;
  }

  .card-text p {
    font-size: 14px;
  }

}

@media (max-width: 800px) {

  .about {
    padding: 30px 15px;
  }

  .section-header {
    margin-bottom: 10px;
  }

  .about-cards {
    flex-direction: column;
    align-items: center;
    gap: 10px;
  }

  .about-card {
    width: 350px;
    border-radius: 16px;
    padding: 10px;
  }

  .card-header h3 {
    font-size: 16px;
  }

  .about-icon {
    width: 25px;
    height: 25px;
  }

  .card-subtitle {
    font-size: 12px;
  }

  .card-text p {
    font-size: 12px;
    margin-bottom: 10px;
  }

}
</style>